var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg8E85Af30Cecd69A3F52727D6Eb0B9A9496A8Be89(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 24 26.6667",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 26.6667C18.4482 26.6667 23.6756 21.4883 23.6756 15.1005C23.6756 8.71262 18.4482 3.53425 12 3.53425C5.55177 3.53425 0.324451 8.71262 0.324451 15.1005C0.324451 21.4883 5.55177 26.6667 12 26.6667ZM12 8.99607C12.5374 8.99607 12.973 9.4276 12.973 9.95992V14.7012L15.9312 17.6317C16.3112 18.0082 16.3112 18.6184 15.9312 18.9948C15.5512 19.3712 14.9352 19.3712 14.5552 18.9948L11.312 15.782C11.1295 15.6012 11.027 15.3561 11.027 15.1005V9.95992C11.027 9.4276 11.4626 8.99607 12 8.99607Z",
    fill: "var(--fill-0, white)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.98733 0.453142C7.27212 0.904549 7.1336 1.4992 6.67792 1.78132L1.48876 4.99416C1.03308 5.27629 0.432816 5.13906 0.148021 4.68765C-0.136774 4.23625 0.00175116 3.6416 0.457426 3.35947L5.64659 0.146635C6.10226 -0.135493 6.70253 0.00173477 6.98733 0.453142Z",
    fill: "var(--fill-0, white)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0127 0.45314C17.2975 0.00173339 17.8978 -0.135493 18.3534 0.146636L23.5426 3.35947C23.9983 3.6416 24.1368 4.23625 23.852 4.68766C23.5672 5.13906 22.9669 5.27629 22.5112 4.99416L17.3221 1.78132C16.8664 1.49919 16.7279 0.904546 17.0127 0.45314Z",
    fill: "var(--fill-0, white)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg8E85Af30Cecd69A3F52727D6Eb0B9A9496A8Be89);
export default __webpack_public_path__ + "static/media/8e85af30cecd69a3f52727d6eb0b9a9496a8be89.1a074df2f45b060e6f06f138d2e11f60.svg";
export { ForwardRef as ReactComponent };